import React, { lazy } from 'react';
import { Instagram, MapPin } from 'lucide-react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="w-full bg-charcoal text-gold py-12 px-4" data-id="element-24">
      <div className="max-w-7xl mx-auto" data-id="element-25">
        <div className="flex flex-col items-center space-y-8" data-id="element-26">
          <Logo size="small" data-id="element-27" />

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 text-center md:text-left w-full" data-id="element-28">
            <div className="flex flex-col items-center md:items-start gap-4" data-id="element-29">
              <a href="https://instagram.com/vrbeautystudio.uy" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-gold/80 transition-colors" data-id="element-30">
                <Instagram className="w-5 h-5" data-id="element-31" />
                <span data-id="element-32">@vrbeautystudio.uy</span>
              </a>

              <div className="flex items-center gap-2" data-id="element-33">
                <MapPin className="w-5 h-5" data-id="element-34" />
                <span data-id="element-35">Bulevar España 2654, Montevideo, Uruguay</span>
              </div>
            </div>

            <div className="w-full max-w-md h-48 rounded-xl overflow-hidden border-2 border-gold/30 shadow-lg" data-id="element-36">
              <iframe src="https://maps.google.com/maps?q=Bulevar%20Espa%C3%B1a%202654,%20Montevideo,%20Uruguay&t=&z=15&ie=UTF8&iwloc=&output=embed" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Ubicación VR Beauty Studio en Bulevar España" data-id="element-37" />
            </div>
          </div>

          <div className="w-full border-t border-gold/20 pt-8 text-center text-gold/60" data-id="element-38">
            <p data-id="element-39">© 2025 VR Beauty Studio. Todos los derechos reservados.</p>
          </div>
        </div>
      </div>
    </footer>;
}